import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bulma/css/bulma.css";
import 'bulma/css/bulma.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

/*
ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
*/